/**
 * HighlightBadge
 * Viñeta destacada para superponer en imagen de eventos, productos y planes.
 * Color personalizable. Si el bg es claro (amarillo) usa texto negro
 * automáticamente para contraste WCAG.
 */
const DEFAULT_BG = "#FF4D00";

// Color hex → ¿es claro? (luminancia perceptual)
function isLightHex(hex) {
  if (!hex || typeof hex !== "string") return false;
  const h = hex.replace("#", "");
  if (h.length !== 6) return false;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  // YIQ
  return (r * 299 + g * 587 + b * 114) / 1000 > 165;
}

export function HighlightBadge({ text, color, className = "", position = "top-left" }) {
  if (!text || !String(text).trim()) return null;
  const bg = color || DEFAULT_BG;
  const fg = isLightHex(bg) ? "#0A0A0A" : "#FFFFFF";
  const pos = position === "top-right" ? "top-2 right-2" : "top-2 left-2";
  return (
    <span
      data-testid="highlight-badge"
      style={{ backgroundColor: bg, color: fg }}
      className={`absolute ${pos} text-[10px] sm:text-xs font-black uppercase tracking-wider px-2.5 py-1 shadow-lg shadow-black/30 backdrop-blur-sm z-10 pointer-events-none ${className}`}
    >
      {text}
    </span>
  );
}

// Paleta predefinida que se muestra en el admin
export const BADGE_COLORS = [
  { value: "", label: "Naranja", hex: "#FF4D00" },     // default
  { value: "#DC2626", label: "Rojo", hex: "#DC2626" },
  { value: "#16A34A", label: "Verde", hex: "#16A34A" },
  { value: "#2563EB", label: "Azul", hex: "#2563EB" },
  { value: "#EAB308", label: "Amarillo", hex: "#EAB308" },
  { value: "#7C3AED", label: "Morado", hex: "#7C3AED" },
  { value: "#0F0F0F", label: "Negro", hex: "#0F0F0F" },
];
